import React from "react";
import {
  RelatorioInadimplentesItem,
  RelatorioInadimplentesFields,
} from "core/features/relatorios/typings";
import { View, Text } from "@react-pdf/renderer";
import { commonRelatorioPdfStyles } from "components/Relatorio/styles";
import { PDFTable } from "ui/components/PDF";
import useRelatorioInadimplentesPdfColumns from "./hooks/useRelatorioInadimplentesPdfColumns";
import TotalRow from "../TotalRow";
import PDFTag from "ui/components/PDF/components/Tag";
import { tagSetorJuridicoString } from "features/conta/typings";

interface PDFRelatorioInadimplentesItemTableProps {
  item: RelatorioInadimplentesItem;
  selectedFields?: RelatorioInadimplentesFields[];
}

function ItemTable({
  item,
  selectedFields,
}: PDFRelatorioInadimplentesItemTableProps) {
  const columns = useRelatorioInadimplentesPdfColumns({
    selectedFields,
  });

  return (
    <View>
      <View style={commonRelatorioPdfStyles.itemTableTitleRow}>
        <Text style={commonRelatorioPdfStyles.itemTableTitle}>
          {selectedFields?.includes("unidade") ? item.unidade : ""}
          {selectedFields?.includes("responsavel") && item.responsavel
            ? " - " + item.responsavel
            : ""}
        </Text>
        {selectedFields?.includes("unidade") && item.isJuridico ? (
          <View style={{ marginLeft: 4 }}>
            <PDFTag text={tagSetorJuridicoString} />
          </View>
        ) : undefined}
        {selectedFields?.includes("unidade") && item.isAjuizada ? (
          <View style={{ marginLeft: 4 }}>
            <PDFTag text="Ajuizada" />
          </View>
        ) : undefined}
      </View>
      {columns.length ? (
        <PDFTable
          data={item.contas}
          columns={columns}
          tableHeaderVariant="rowLike"
        />
      ) : null}
      {columns.length ? (
        <View style={commonRelatorioPdfStyles.itemTableSummary}>
          <TotalRow title="Total" {...item} selectedFields={selectedFields} />
        </View>
      ) : null}
    </View>
  );
}

export default ItemTable;
